import React from 'react';
import { Tooltip } from 'mj-design';

export default () => (
  <Tooltip />
);
